import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fdaf2040&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdaf2040')) {
      api.createRecord('fdaf2040', component.options)
    } else {
      api.reload('fdaf2040', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fdaf2040&", function () {
      api.rerender('fdaf2040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fdWbAyQ59AU3/JS/offershelp.vue"
export default component.exports